import { useEffect, useState } from "react";
import Api from "../openapi";
import { AdminPriceOfferResponse } from "../openapi/client";
import { checkIf } from "../utils";

export default function usePriceOffer(
  zone?: number,
  planOptionId?: string,
  assignedDays?: number,
  discountCode?: string
) {
  const [priceOffer, setPriceOffer] = useState<AdminPriceOfferResponse>();

  useEffect(() => {
    const getPriceOffer = async () => {
      try {
        const res = await Api.PriceOffer.getPriceOfferForAdmin(
          Number(zone),
          String(planOptionId),
          Number(assignedDays),
          discountCode
        );
        setPriceOffer(res.data);
      } catch (error) {}
    };
    if (checkIf(zone) && checkIf(planOptionId) && checkIf(assignedDays)) {
      getPriceOffer();
    } else {
      setPriceOffer(undefined);
    }
  }, [zone, planOptionId, assignedDays, discountCode]);
  return priceOffer;
}
